import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import BtnAdd from '../../../../Components/Utility/FilterAction/BtnAdd';
import BtnSelectAll from '../../../../Components/Utility/FilterAction/BtnSelectAll';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as action from '../Store/Testing.action';
import Loader from '../../../../Components/Utility/Loader/Loader';
import TestingGroupCard from '../../../../Components/Card/TestingGroupCard/TestingGroupCard';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';

function TestingLibraryGroup() {
  const { t } = useTranslation('common');
  const testingGroupReduxData = useSelector((redState) => redState);
  const { UserDetails, TestDetails } = testingGroupReduxData;
  const { userInfo } = UserDetails;
  const { groupList } = TestDetails;
  const dispatch = useDispatch();

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);
  const [colourDeleteId, setColourDeleteId] = useState(null);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [state, setState] = useState({
    colourLibraryGroups: [],
    loading: false,
    searchText: '',
    searchLoaded: false,
    sortBy: null,
  });
  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const { CheckActionPermission } = useComponent();

  const testingAddEditAccess = CheckActionPermission(userRights, 'libraries', 'testing', 'addEdit');
  const testingDeleteAccess = CheckActionPermission(userRights, 'libraries', 'testing', 'delete');

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobState) => ({
        ...mobState,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  useEffect(() => {
    async function fetchApi() {
      if (userInfo?.userId) {
        const res = await dispatch(action.getTestingGroup());
        if (res) {
          setState((states) => ({
            ...states,
            loading: false,
          }));
        }
      }
    }

    setState((states) => ({
      ...states,
      loading: true,
    }));
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (groupList) {
      setState((colState) => ({
        ...colState,
        colourLibraryGroups: [...groupList],
        loading: false,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupList]);

  const handleDeleteCard = async (id) => {
    setColourDeleteId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of state.colourLibraryGroups) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const deleteById = async () => {
    setShowConfirmationPopup(!showConfirmationPopup);
    setState((delState) => ({
      ...delState,
      loading: true,
    }));
    const params = {
      loggedInUserId: userInfo.userId,
    };
    if (colourDeleteId) {
      params.groupIds = JSON.stringify([colourDeleteId]);
    } else {
      params.groupIds = JSON.stringify([...selectedIdArray]);
    }
    dispatch(action.deleteTestGroup(params, t));
    dispatch(action.getTestingGroup());
    setState((delIdState) => ({
      ...delIdState,
      loading: false,
    }));
  };

  const onSelectCheckBox = async (_e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((seState) => ({
      ...seState,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((delState) => ({
          ...delState,
          loading: true,
          colourLibraryGroups: [],
        }));
        setSelectedIdArray([]);
        setSelectAll(false);
        const params = {
          loggedInUserId: userInfo.userId,
          searchText: state.searchText,
          sortBy: state.sortBy,
        };
        dispatch(action.getTestingGroup(params));
        setState((getState) => ({
          ...getState,
          loading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteColourType = (id) => {
    setColourDeleteId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.TITLE')}</h4>
        </div>
        <div className="search-filter ">
          <SearchBar
            onSearch={handleSearch}
            value={state.searchText}
            placeholder={t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.SEARCH_TESTING_GROUP')}
            showMobileSearch={showSearchMobile}
            handleMobileSearch={handleMobileSearch}
          />
          <Link className="cursor-pointer text-dark text-decoration-none " to="/libraries/testing-group/add">
            <BtnAdd addEditAccess={testingAddEditAccess} />
          </Link>
          {testingDeleteAccess && (
            <BtnDelete
              multiDelete={() => {
                deleteColourType(null);
              }}
              isDisabled={selectedIdArray.length <= 0}
            />
          )}

          {testingAddEditAccess || testingDeleteAccess ? (
            <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={state.colourLibraryGroups.length <= 0} />
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="container-fluid">
        <div className="d-flex justify-content-end my-3">
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/testing-library') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/libraries/testing"
          >
            <span className="lib-name">{t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.TESTING')}</span>
          </Link>
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/testing-group') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/libraries/testing-group"
          >
            <span className="lib-name">{t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.TITLE')}</span>
          </Link>
        </div>
        {!state.loading && state.colourLibraryGroups.length === 0 && (
          <div>
            <div className="w-100 text-center">
              <Container fluid className="py-4">
                <Row>
                  <Col md="12">
                    <p className="alert alert-info override-alert-info">{t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.NO_TESTING_GROUPS_FOUND')}</p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
      {state.loading && <Loader />}
      {state?.colourLibraryGroups?.length > 0 && (
        <div className="container-fluid">
          <div className="row info-data-style">
            {state.colourLibraryGroups.map((item, i) => {
              return (
                <React.Fragment key={item?._id || i}>
                  <TestingGroupCard
                    editeble
                    item={item}
                    index={i}
                    onDelete={handleDeleteCard}
                    onCheck={onSelectCheckBox}
                    selectedIds={selectedIdArray}
                    isImport={false}
                    testingAddEditAccess={testingAddEditAccess}
                    testingDeleteAccess={testingDeleteAccess}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={state.loading}
          title={t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.DELETE_TESTING_GROUP')}
          message={t('TESTINGS.TESTING_GROUP.TESTING_GROUPS.CONFIRM_DELETE_TESTING_GROUP')}
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
    </>
  );
}

export default TestingLibraryGroup;
